var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "@atlaskit/css-reset/dist/bundle.css";
import { createGlobalStyle, ThemeProvider } from "styled-components";
var defaultTheme = {
    borderRadius: 2,
    spacing: 5,
    fontSize: {
        large: "1rem",
        medium: "0.8rem",
        small: "0.75rem",
        legal: "0.6rem",
    },
    color: {
        primary: "#273b58",
        error: "#DE350B",
        info: "#0051D4",
        gray: "#CCCCCC",
        dark: "#808080",
        success: "#d1e7dd",
    },
    border: {
        success: "#a3cfbb",
    },
    text: {
        success: "#0a3622",
    },
};
var StyledBackground = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  body {\n    background: #f2f2f2;\n  }\n"], ["\n  body {\n    background: #f2f2f2;\n  }\n"])));
export default (function (props) {
    return (_jsxs(ThemeProvider, __assign({ theme: defaultTheme }, { children: [_jsx(StyledBackground, {}), props.children] })));
});
var templateObject_1;
//# sourceMappingURL=index.js.map